import { Transition, Dialog } from "@headlessui/react";
import { useState, useEffect, useRef, Fragment } from "react";
import { useNavigate } from "react-router";
import ComingSoonModal from "../../components/coming_soon_modal.jsx";

// export default function PayMembershipPlanModal({ setOpenModal, selectedPlan }) {
//     const [selectedOption, setSelectedOption] = useState("course");

//     const [courseCode, setCourseCode] = useState("");
//     const [voucherCode, setVoucherCode] = useState("");

//     const [savedCourseCodes, setSavedCourseCodes] = useState([]);
//     const [savedVoucherCodes, setSavedVoucherCodes] = useState([]);

//     const [courseApplied, setCourseApplied] = useState(false);
//     const [voucherApplied, setVoucherApplied] = useState(false);
//     const [errorMessage, setErrorMessage] = useState("");
//     const [showCourseDropdown, setShowCourseDropdown] = useState(false);
//     const [showVoucherDropdown, setShowVoucherDropdown] = useState(false);

//     // 🔹 Case-Sensitive Mock Database of Valid Codes
//     const validCourseCodes = ["2024SEP", "2024OCT"];
//     const validVoucherCodes = ["VOUCHER123", "DISCOUNT50"];

//     // 🔹 Refs for detecting clicks outside dropdowns
//     const courseDropdownRef = useRef(null);
//     const voucherDropdownRef = useRef(null);

//     // 🔹 Load previously entered codes from localStorage
//     useEffect(() => {
//         const storedCourses = JSON.parse(localStorage.getItem("savedCourseCodes")) || [];
//         const storedVouchers = JSON.parse(localStorage.getItem("savedVoucherCodes")) || [];
//         setSavedCourseCodes(storedCourses);
//         setSavedVoucherCodes(storedVouchers);
//     }, []);

//     // 🔹 Close dropdown when clicking outside
//     useEffect(() => {
//         function handleClickOutside(event) {
//             if (courseDropdownRef.current && !courseDropdownRef.current.contains(event.target)) {
//                 setShowCourseDropdown(false);
//             }
//             if (voucherDropdownRef.current && !voucherDropdownRef.current.contains(event.target)) {
//                 setShowVoucherDropdown(false);
//             }
//         }

//         document.addEventListener("mousedown", handleClickOutside);
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, []);

//     const handleApplyCourseCode = () => {
//         if (!savedCourseCodes.includes(courseCode)) {
//             const updatedCourses = [...new Set([...savedCourseCodes, courseCode])];
//             setSavedCourseCodes(updatedCourses);
//             localStorage.setItem("savedCourseCodes", JSON.stringify(updatedCourses));
//         }

//         if (validCourseCodes.includes(courseCode)) {
//             setCourseApplied(true);
//             setVoucherApplied(false);
//             setErrorMessage("");
//         } else {
//             setErrorMessage("Incorrect course code applied! (Case-sensitive)");
//         }
//     };

//     const handleApplyVoucherCode = () => {
//         if (!savedVoucherCodes.includes(voucherCode)) {
//             const updatedVouchers = [...new Set([...savedVoucherCodes, voucherCode])];
//             setSavedVoucherCodes(updatedVouchers);
//             localStorage.setItem("savedVoucherCodes", JSON.stringify(updatedVouchers));
//         }

//         if (validVoucherCodes.includes(voucherCode)) {
//             setVoucherApplied(true);
//             setCourseApplied(false);
//             setErrorMessage("");
//         } else {
//             setErrorMessage("Incorrect voucher code applied! (Case-sensitive)");
//         }
//     };

//     const handleProceed = () => {
//         console.log(`Plan: ${selectedPlan}, Course: ${courseCode}, Voucher: ${voucherCode}`);
//         setOpenModal(false);
//     };

//     return (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//             <div className="bg-white p-6 shadow-lg w-96 text-black">
//                 <h2 className="text-lg font-bold mb-4 text-center">Redeem a Code or Continue</h2>

//                 {/* Error & Success Messages */}
//                 {errorMessage && (
//                     <div className="bg-red-500 text-white text-sm p-2 rounded mb-2 text-center">
//                         {errorMessage}
//                     </div>
//                 )}
//                 {courseApplied && (
//                     <div className="bg-green-500 text-white text-sm p-2 rounded mb-2 text-center">
//                         Course Code Applied Successfully!
//                     </div>
//                 )}
//                 {voucherApplied && (
//                     <div className="bg-green-500 text-white text-sm p-2 rounded mb-2 text-center">
//                         Voucher Code Applied Successfully!
//                     </div>
//                 )}

//                 {/* Radio Buttons */}
//                 <div className="space-y-4">
//                     {/* Redeem Course Code */}
//                     <div>
//                         <label className={`flex items-center space-x-2 text-black ${voucherApplied ? "opacity-50 cursor-not-allowed" : ""}`}>
//                             <input
//                                 type="radio"
//                                 value="course"
//                                 checked={selectedOption === "course"}
//                                 onChange={() => setSelectedOption("course")}
//                                 disabled={voucherApplied}
//                             />
//                             <span>Redeem Course Code</span>
//                         </label>

//                         {selectedOption === "course" && (
//                             <div className="mt-2 flex items-center space-x-2 relative">
//                                 <div className="relative w-full" ref={courseDropdownRef}>
//                                     <input
//                                         type="text"
//                                         className="border px-3 py-2 w-full text-black bg-white"
//                                         placeholder="Enter course code"
//                                         value={courseCode}
//                                         onChange={(e) => setCourseCode(e.target.value)}
//                                         onFocus={() => !courseApplied && setShowCourseDropdown(true)}
//                                         disabled={voucherApplied || courseApplied}
//                                     />

//                                     {/* Dropdown */}
//                                     {!courseApplied && showCourseDropdown && savedCourseCodes.length > 0 && (
//                                         <ul className="absolute left-0 w-full mt-1 bg-white border border-gray-300 shadow-lg max-h-40 overflow-y-auto rounded-md">
//                                             {savedCourseCodes.map((code, index) => (
//                                                 <li
//                                                     key={index}
//                                                     className="p-2 hover:bg-gray-100 cursor-pointer transition"
//                                                     onClick={() => {
//                                                         setCourseCode(code);
//                                                         setShowCourseDropdown(false);
//                                                     }}
//                                                 >
//                                                     {code}
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     )}
//                                 </div>

//                                 {!courseApplied && (
//                                     <button className="bg-blue-500 text-white px-4 py-2" onClick={handleApplyCourseCode} disabled={voucherApplied}>
//                                         Apply
//                                     </button>
//                                 )}
//                             </div>
//                         )}
//                     </div>

//                     {/* Redeem Voucher Code */}
//                     <div>
//                         <label className={`flex items-center space-x-2 text-black ${courseApplied ? "opacity-50 cursor-not-allowed" : ""}`}>
//                             <input
//                                 type="radio"
//                                 value="voucher"
//                                 checked={selectedOption === "voucher"}
//                                 onChange={() => setSelectedOption("voucher")}
//                                 disabled={courseApplied}
//                             />
//                             <span>Redeem Voucher Code</span>
//                         </label>

//                         {selectedOption === "voucher" && (
//                             <div className="mt-2 flex items-center space-x-2 relative">
//                                 <div className="relative w-full" ref={voucherDropdownRef}>
//                                     <input
//                                         type="text"
//                                         className="border px-3 py-2 w-full text-black bg-white"
//                                         placeholder="Enter voucher code"
//                                         value={voucherCode}
//                                         onChange={(e) => setVoucherCode(e.target.value)}
//                                         onFocus={() => !voucherApplied && setShowVoucherDropdown(true)}
//                                         disabled={courseApplied || voucherApplied}
//                                     />

//                                     {/* Dropdown */}
//                                     {!voucherApplied && showVoucherDropdown && savedVoucherCodes.length > 0 && (
//                                         <ul className="absolute left-0 w-full mt-1 bg-white border border-gray-300 shadow-lg max-h-40 overflow-y-auto rounded-md">
//                                             {savedVoucherCodes.map((code, index) => (
//                                                 <li
//                                                     key={index}
//                                                     className="p-2 hover:bg-gray-100 cursor-pointer transition"
//                                                     onClick={() => {
//                                                         setVoucherCode(code);
//                                                         setShowVoucherDropdown(false);
//                                                     }}
//                                                 >
//                                                     {code}
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     )}
//                                 </div>

//                                 {!voucherApplied && (
//                                     <button className="bg-blue-500 text-white px-4 py-2" onClick={handleApplyVoucherCode} disabled={courseApplied}>
//                                         Apply
//                                     </button>
//                                 )}
//                             </div>
//                         )}
//                     </div>

//                     {/* Continue Without Code */}
//                     <div>
//                         <label className={`flex items-center space-x-2 text-black ${courseApplied || voucherApplied ? "opacity-50 cursor-not-allowed" : ""}`}>
//                             <input
//                                 type="radio"
//                                 value="continue"
//                                 checked={selectedOption === "continue"}
//                                 onChange={() => setSelectedOption("continue")}
//                                 disabled={courseApplied || voucherApplied}
//                             />
//                             <span>Continue without code</span>
//                         </label>
//                     </div>
//                 </div>

//                 {/* Buttons */}
//                 <div className="flex justify-between mt-6">
//                     <button className="border border-red-500 text-red-500 px-4 py-2 w-1/2" onClick={() => setOpenModal(false)}>Cancel</button>
//                     <button className="bg-blue-500 text-white px-4 py-2 w-1/2" onClick={handleProceed}>Proceed</button>
//                 </div>
//             </div>
//         </div>
//     );
// }

export default function PayMembershipPlanModal({
  setOpenModal,
  devProj,
  industryApiOptions,
  organisationApiOptions,
  currentTab,
  plan
}) {
  const [open, setOpen] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [comingSoonDate, setComingSoonDate] = useState(null);
  const handleComingSoonClick = (date) => {
    setComingSoonDate(date);
    setIsOpen(true);
  };
  const handleCloseComingSoon = () => {
    setIsOpen(false);
    setComingSoonDate(null);
  };

  //   function handleEdit() {
  //     const projectNamesString = plan.project_name_preset;
  //     const projectNames = projectNamesString
  //       .split("|")
  //       .map((name) => name.toLowerCase());
  //     const industryApis = industryApiOptions
  //       .filter((project) => projectNames.includes(project.project_name))
  //       .map((project) => ({
  //         value: project.project_id,
  //         label: project.project_name,
  //       }));
  //     const organisationApis = organisationApiOptions
  //       .filter((project) => projectNames.includes(project.project_name))
  //       .map((project) => ({
  //         value: project.project_id,
  //         label: project.project_name,
  //       }));

  //     let environment;

  //     if (currentTab.name === "Certification") {
  //       const isGoLive =
  //         plan.certification_category.includes("Go Live");
  //       environment = isGoLive
  //         ? { value: "1", label: "Production" }
  //         : { value: "0", label: "Staging" };
  //     } else {
  //       const isProduction = currentTab.name !== "Staging";
  //       environment = isProduction
  //         ? { value: "1", label: "Production" }
  //         : { value: "0", label: "Staging" };
  //     }
  //     const presetOptions = {
  //       environment: environment,
  //       invoicePlanSyscode: devProj.invoice_plan_syscode,
  //       industryApiOptions: industryApis,
  //       organisationApiOptions: organisationApis,
  //       subscriptionId: {
  //         value: plan.developer_certification_plan_id,
  //         label: plan.certification_plan,
  //       },
  //       developerProjName: devProj.developer_proj_name,
  //       developerProjId: devProj.developer_proj_id,
  //       platformSyscode: devProj.platform_syscode,
  //       websiteUrl: devProj.developer_proj_website_url,
  //     };
  //     navigate("/projects/create", {state: { presetOptions: presetOptions }});
  //   }
  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0 overflow-y-auto"
          onClose={setOpen}
        >
          <div className="flex items-center justify-center min-h-screen">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay
                className="fixed inset-0 bg-gray-500 opacity-75 transition-opacity"
                onClick={() => setOpenModal(false)}
              />
            </Transition.Child>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                <div>
                  <div className="mt-3 sm:mt-5">
                    <Dialog.Title
                      as="h3"
                      className="text-lg leading-6 font-medium text-gray-900 mb-3"
                      style={{
                        marginBottom: "25px",
                        marginTop: "-20px",
                        fontSize: "20px",
                      }}
                    >
                      Student Chapter Membership
                    </Dialog.Title>
                    <div className="mt-2 text-black" style={{ fontSize: "19" }}>
                      <p className="block text-sm font-medium ">
                        Annual Membership Fee: {" "}
                        <span className="text-gray-600">$30</span>
                      </p>
                      <p className="block text-sm font-medium mt-2">
                        Student Chapter Membership Benefits:
                      </p>
                      <ul className="list-disc ml-6">
                        <li>
                          20% discounts off all Production API subscriptions
                          {/* {devProj.developer_proj_name} */}
                        </li>
                        <li>
                          Additional 30% discount for active API publishing
                          {/* {devProj.developer_proj_status_type} */}
                        </li>
                        <li>
                          Project portfolio webpage
                          {/* {devProj.developer_proj_status_type} */}
                        </li>
                      </ul>
                      {/* <p className="mt-2 text-sm font-medium">School email for verification:</p> */}
                    </div>
                  </div>
                </div>
                <div className="mt-2 sm:mt-6 flex justify-end space-x-3">
                  <button
                    type="button"
                    className="mt-3 inline-flex justify-center rounded-md px-4 py-2 hover:bg-red-500 text-red-500 hover:text-white outline outline-red-500 font-bold sm:mt-0 sm:col-start-1 sm:text-sm"
                    onClick={() => setOpenModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="inline-flex justify-center border-transparent rounded-md px-4 py-2 bg-gray-500 hover:bg-blue-600 text-white font-bold sm:text-sm"
                    style={{ marginTop: "16px" }}
                    // disabled={true}
                    onClick={() => handleComingSoonClick("End June")}
                    // onClick={() => {
                    //   localStorage.setItem("amount", "30");
                    //   localStorage.setItem("txnId", "foodcanopy|s|29|2|22549|30|dV6GeyFjKIRMiVvy/W1+zLsaznJRfMBNPcOi+ZskW30=");
                    //   localStorage.setItem("description", "Student Chapter Membership");
                    //   navigate("/payments");
                    // }}
                  >
                    Proceed with Payment
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
      {isOpen && (
        <ComingSoonModal
          setOpenModal={handleCloseComingSoon}
          comingSoonDate={comingSoonDate}
        />
      )}
    </>
  );
}

